<template>
  <div>
    <!-- 顶部菜单栏 - 固定定位在最上方 -->
    <div id="topMenu" class="shadow-sm fixed-top" style="background-color: white; z-index: 1000; height: 60px;">
      <el-row class="el-row is-justify-space-between el-row--flex" style="width: 90vw; margin-left: 5vw; height: 100%;">
        <el-col class="d-flex flex-row" :span="4">
          <img src="../../static/不空.jpg" style="height: 50px; width: 180px; object-fit: contain;" alt="logo"/>
        </el-col>
        <el-col class="d-flex" :span="16">
          <el-menu
            mode="horizontal"
            class="el-menu--horizontal el-menu"
            style="background-color: white; border-bottom: none; height: 100%;"
          >
            <el-menu-item index="2" @click="$router.push('/bjsc')">场景</el-menu-item>
            <el-menu-item index="1" @click="$router.push('/rwsc')">人物</el-menu-item>

            <el-menu-item index="3" @click="$router.push('/djsc')">道具</el-menu-item>
            <el-menu-item index="4" @click="$router.push('/bqsc')">表情</el-menu-item>
            <el-menu-item index="5" @click="$router.push('/txsc')">特效</el-menu-item>
            <el-menu-item index="6" @click="$router.push('/yxsc')">音效</el-menu-item>
            <el-menu-item index="9" @click="$router.push('/rjxz')">软件下载</el-menu-item>
          </el-menu>
        </el-col>
        <el-col class="d-flex flex-row-reverse" :span="4">
          <el-button
            type="text"
            :hidden="this.$store.state.btnLoginHidden"
            @click="$store.state.showLoginDialog=true"
            style="height: 100%; padding: 0 15px;"
          >
            登 录
          </el-button>

          <el-dropdown
            @command="btnUser"
            style="height: 100%; display: flex; align-items: center;"
            :hidden="this.$store.state.loginUserHidden"
          >
            <span class="el-dropdown-link">
              {{ this.$store.state.useraccount }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zhdj">账号登记</el-dropdown-item>
              <el-dropdown-item command="updatepwd">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>

    <!-- 跑马灯公告栏 - 放在菜单下方 -->
    <div class="announcement-bar">
      <div class="marquee-wrapper">
        <div class="marquee-content">
          网站素材均已注册版权！全站素材+插件+学习=99！插件永久使用，支持换机！素材网每周更新！
        </div>
      </div>
    </div>

    <!-- 对话框部分保持不变 -->
    <el-dialog title="不空素材网--账号登记" width="500px" modal="false" append-to-body modal-append-to-body="false"
               :visible.sync="$store.state.showZhdjDialog">
      <el-form :model="user">
        <el-form-item label="所属平台" :label-width="formLabelWidth">
          <el-select v-model="plat.lx" placeholder="请选择所属平台">
            <el-option label="抖音" value="1"></el-option>
            <el-option label="快手" value="2"></el-option>
            <el-option label="B站" value="3"></el-option>
            <!--            <el-option label="百家号" value="4"></el-option>-->
            <!--            <el-option label="今日头条" value="5"></el-option>-->
            <!--            <el-option label="西瓜视频" value="6"></el-option>-->
            <!--            <el-option label="小红书" value="7"></el-option>-->
          </el-select>
        </el-form-item>
        <el-form-item label="平台Id" :label-width="formLabelWidth">
          <el-input v-model="plat.platno" placeholder="请输入平台Id"></el-input>
        </el-form-item>
        <el-form-item label="您当前绑定信息" :label-width="formLabelWidth">
          {{ this.platcontent }}
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="btnOK2">确 定</el-button>
        <el-button type="primary" @click="btnClose2">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="不空素材网--修改密码" width="500px" modal="false" append-to-body modal-append-to-body="false" :visible.sync="$store.state.pwdDialogVisible">
      <el-form :model="user">
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <input  v-model="user.pwd1" type="password" placeholder="请输入密码" class="el-input__inner">
          <p v-if="user.pwd1.length < 8">密码长度必须大于8位</p>
          <p v-else>密码长度合适</p>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth">
          <input  v-model="user.pwd2" type="password" placeholder="请输入密码" class="el-input__inner">
          <p v-if="user.pwd2.length < 8">密码长度必须大于8位</p>
          <p v-else>密码长度合适</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="btnOK">确 定</el-button>
        <el-button type="primary" @click="btnClose">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="不空动画-沙雕动画素材网" width="560px" modal="false" append-to-body modal-append-to-body="false" :visible.sync="$store.state.showLoginDialog">
      <el-form :model="form">
        <el-form-item label="账 号" :label-width="formLabelWidth">
          <el-input v-model="form.account" autocomplete="off" placeholder="请输入账号" show-password></el-input>
        </el-form-item>
        <el-form-item label="密 码" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="微信" :label-width="formLabelWidth">
          emo277475843
        </el-form-item>
        <el-form-item label="淘宝" :label-width="formLabelWidth">
            <div style="text-align: left; ">
            <a target="_blank" style="font-size: 16px; color: #409EFF;" href="https://item.taobao.com/item.htm?abbucket=17&detail_redpacket_pop=true&id=779224901248&ltk2=1744333868305y7y1pa3sq4kedw31lbmiq&ns=1&priceTId=undefined&query=%E4%B8%8D%E7%A9%BAan%E6%8F%92%E4%BB%B6&spm=a21n57.1.hoverItem.2&utparam=%7B%22aplus_abtest%22%3A%225bf94226882e8ad8b0cdf0d799e75c24%22%7D&xxc=taobaoSearch" >不空插件</a>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="btnLogin">确 定</el-button>
        <el-button @click="$store.state.showLoginDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { loginout } from '../api/userMG'
import {addUserPlat, getUserPlat, login, updatePwd} from '../api/bkUser'
import { setStore,getStore,removeStore } from '../utils/util'

export default {
  name: 'bkHeader',
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        account: '',
        password: ''
      },
      user:{
        id:0,
        account:'',
        pwd1:'',
        pwd2:''
      },
      plat:{
        lx:0,
        platno:""
      },
      platcontent:"",
      formLabelWidth: '120px'
    }
  },
  created() {
    const id = getStore("id");
    const account = getStore("account");
    const token = getStore("token");

    if(id && token && account){
      this.user.id = id;
      this.user.account = account;

      this.$store.state.userid = id;
      this.$store.state.useraccount = account;
      this.$store.state.showLoginDialog = false;
      this.$store.state.loginUserHidden = false;
      this.$store.state.btnLoginHidden = true;
    }
  },
  methods: {
    btnOK(){
      if(this.user.pwd1.length < 8 || this.user.pwd2.length < 8) {
        this.$message.error("密码长度不能小于8位!");
        return;
      }

      if(this.user.pwd1 !== this.user.pwd2){
        this.$message.error("两次密码输入不一致!");
      } else {
        updatePwd({
          id: this.user.id,
          pwd1: this.user.pwd1,
          pwd2: this.user.pwd2
        }).then((res) => {
          if (res.State === 1) {
            this.$message.success("密码修改成功！");
            this.$store.state.pwdDialogVisible = false;
          } else {
            this.$message.error(res.ErrorMessage);
          }
        });
      }
    },
    btnClose(){
      this.$store.state.pwdDialogVisible=false;
    },
    btnOK2(){
      alert(this.plat.lx);
      var lx = this.plat.lx;
      var platno = this.plat.platno;
      addUserPlat({lx:lx,platno:platno}).then((res) => {
        if(res.State === 1){
          this.$message.success('操作成功！');
          getUserPlat().then((res)=>{
            this.platcontent = res.Data;
          });
        }
        else{
          this.$message.error(res.ErrorMessage);
        }
      });
    },
    btnClose2(){
      this.$store.state.showZhdjDialog=false;
    },
    openNewWindow(ac) {
      var url="";
      // 使用window.open打开新窗口，并导航到指定的URL
      if(ac===1){
        url="https://www.doubao.com/chat/";
      }
      else if(ac===2){
        url="https://yiyan.baidu.com/";
      }
      else if(ac===3){
        url="https://liblib.art/";
      }
      else if(ac===4){
        url="https://upscayl.org/";
      }
      window.open(url, '_blank');
    },
    // 退出登录
    btnUser(ac){
      if(ac==="exit"){
        removeStore("id");
        removeStore("account");
        removeStore("token");

        this.$store.state.loginUserHidden=true;
        this.$store.state.btnLoginHidden=false;
      }
      else if(ac==="updatepwd"){
        this.$store.state.pwdDialogVisible=true;
      }
      else if(ac==="zhdj"){
        this.$store.state.showZhdjDialog = true;

        getUserPlat().then((res)=>{
          this.platcontent = res.Data;
        });
      }
    },
    btnLogin(){
      let account = this.form.account;
      let pwd = this.form.password;
      login({account:account,pwd:pwd}).then((res)=>{
        if(res.State===1){
          var token = res.Data.AccessToken;
          var id = res.Data.id;
          var account = res.Data.account;
          setStore("id",id);
          setStore("account",account);
          setStore("token",token);

          this.user.id=id;
          this.user.account=account;

          this.$store.state.userid=id;
          this.$store.state.useraccount=account;
          this.$store.state.showLoginDialog = false;
          this.$store.state.loginUserHidden=false;
          this.$store.state.btnLoginHidden=true;
        }
        else{
          this.$message.error(res.ErrorMessage);
        }
      });
    }
  }
}
</script>

<style scoped>
/* 顶部菜单样式 */
#topMenu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

/* 跑马灯公告栏样式 */
.announcement-bar {
  position: relative;
  background-color: #fdf6ec;
  color: #e09056;
  height: 50px;
  overflow: hidden;
  width: 100%;
  margin-top: 60px; /* 等于菜单高度 */
  z-index: 999;
  display: flex;
  align-items: center;
}

.marquee-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.marquee-content {
  display: inline-block;
  white-space: nowrap;
  padding-left: 100%;
  animation: marquee 20s linear infinite;
  font-size: 18px;
  font-weight: 500;
  line-height: 50px;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
}

/* 响应式设计 */
@media (max-width: 768px) {
  #topMenu {
    height: 50px;
  }

  .announcement-bar {
    height: 40px;
    margin-top: 50px;
  }

  .marquee-content {
    font-size: 16px;
    line-height: 40px;
  }
}

@media (max-width: 480px) {
  #topMenu {
    height: 40px;
  }

  .announcement-bar {
    height: 30px;
    margin-top: 40px;
  }

  .marquee-content {
    font-size: 14px;
    line-height: 30px;
  }
}

/* Element UI 菜单项样式调整 */
.el-menu--horizontal > .el-menu-item {
  height: 100%;
  display: inline-flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue